/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BeginPairingMobileDeviceResponse
 */
export interface BeginPairingMobileDeviceResponse {
    /**
     * Single-use pairing nonce to encode in the QR code (payload "fs-pair:<nonce>").
     * @type {string}
     * @memberof BeginPairingMobileDeviceResponse
     */
    nonce: string;
    /**
     * ISO-8601 instant the nonce expires; the UI shows a countdown and can regenerate.
     * @type {string}
     * @memberof BeginPairingMobileDeviceResponse
     */
    expiresAt: string;
}

/**
 * Check if a given object implements the BeginPairingMobileDeviceResponse interface.
 */
export function instanceOfBeginPairingMobileDeviceResponse(value: object): value is BeginPairingMobileDeviceResponse {
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function BeginPairingMobileDeviceResponseFromJSON(json: any): BeginPairingMobileDeviceResponse {
    return BeginPairingMobileDeviceResponseFromJSONTyped(json, false);
}

export function BeginPairingMobileDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeginPairingMobileDeviceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nonce': json['nonce'],
        'expiresAt': json['expiresAt'],
    };
}

  export function BeginPairingMobileDeviceResponseToJSON(json: any): BeginPairingMobileDeviceResponse {
      return BeginPairingMobileDeviceResponseToJSONTyped(json, false);
  }

  export function BeginPairingMobileDeviceResponseToJSONTyped(value?: BeginPairingMobileDeviceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nonce': value['nonce'],
        'expiresAt': value['expiresAt'],
    };
}

